<template>
  <div id="app">
    <bf-header></bf-header>
    <router-view />
    <FixedTool />
    <bf-footer></bf-footer>

<!--    <div class="modal-score">-->
<!--      <div class="modal-body">-->
<!--        <img src="./assets/score.png" />-->
<!--        <a href="/app" class="download"></a>-->
<!--        <a href="javascript:;" class="close"></a>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import BfFooter from "./components/Footer";
import BfHeader from "./components/Header";
import FixedTool from "./components/FixedTool.vue";
export default {
  name: "App",
  components: {
    BfHeader,
    BfFooter,
    FixedTool
  },
  mounted() {
    if (location.href.indexOf("ios") > -1) {
      $("header").css("display", "none");
    }
    setTimeout(function () {
      if (location.href.indexOf("exit") == -1) {
        $("#app>div").css("minHeight", $(window).height() - 110);
      }
      if (location.href.indexOf("ios") != -1) {
        $("#app>div").css("minHeight", $(window).height());
      }
    }, 1000);

    var $modal = $('.modal-score')
    $modal.on('click', '.close', function () {
      $modal.remove()
    })
  },
};
</script>

<style>
@import "./assets/css/main.css";
@import "./assets/css/base.css";

#app {
  background: #fff;
}
.fc-red {
  color: #e24949;
}
</style>

<style lang="less">
.modal {
  top: 50%;
  transform: translateY(-50%);
  border-radius: 10px;
  padding: 26px 48px 30px 48px;
  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__headerbtn {
    position: absolute;
    top: -50px;
    right: -18px;
    width: 36px;
    height: 36px;
    background: url("./assets/modal-close.png") no-repeat center center;
    background-size: contain;
    .el-icon {
      display: none;
    }
  }
  &-form {
    margin-top: 20px;
    display: flex;
    align-items: center;
    border-bottom: rgba(0, 0, 0, 0.15) 1px solid;

    input {
      flex: 1;
      font-size: 14px;
      font-weight: 400;
      line-height: 34px;
      height: 34px;
    }
    select {
      margin-left: 10px;
      min-width: 100px;
      height: 28px;
      padding: 0 4px;
      border: rgba(0, 0, 0, 0.15) 1px solid;
    }
  }
  &-button {
    margin-top: 36px;
    button {
      outline: none;
      border: 0;
      box-shadow: none;
      width: 62px;
      height: 28px;
      background: #e24949;
      border-radius: 6px;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;
      color: #ffffff;
    }
  }
}

.modal-score {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1199;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: none;
  .modal-body {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 458px;
    transform: translate(-50%, -50%);
    background-color: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  img {
    display: block;
    width: 100%;
  }
  a.download {
    display: block;
    position: absolute;
    top: 378px;
    left: 50%;
    width: 254px;
    height: 51px;
    transform: translateX(-51%);
  }
  a.close {
    margin-top: 30px;
    width: 36px;
    height: 36px;
    background: url("./assets/modal-close.png") no-repeat center center;
    background-size: contain;
  }
}
</style>